import { render, staticRenderFns } from "./EditSubCategory.vue?vue&type=template&id=8a326276&scoped=true&"
import script from "./EditSubCategory.vue?vue&type=script&lang=js&"
export * from "./EditSubCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a326276",
  null
  
)

export default component.exports